import { initialize as initializePop, appendPeriodOverPeriodProperties } from '../util/update-pop-property-for-filter';

export class PortfolioBidStrategySchemaProcessor {
  constructor(options) {
    initializePop(options);
  }

  updateOdataOptions(odataOptions) {
    return odataOptions;
  }

  updateEntitySchemaForFeatures(entitySchema) {
    appendPeriodOverPeriodProperties(entitySchema);
    return entitySchema;
  }
}
